// pages/NotFound.jsx
import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <main className="flex flex-col items-center justify-center min-h-screen w-full bg-fergo-bg gap-4 px-4 text-center">
      <h1 className="text-white/80 font-bold text-6xl">404 - Not found</h1>
      <p className="text-white/60 text-lg">
        La página que buscas no existe.
      </p>
      <Link
        to="/"
        className="text-fergo-accentLight hover:underline font-light tracking-wide"
      >
        Volver al inicio
      </Link>
    </main>
  );
}